import styled from "styled-components";

export const StyledDropdown = styled.div`

  .ant-select {
    width: 100%;
    display: flex; 
    align-items: center;
    // border-radius: 46px;
    // box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  }

  .ant-form-item-additional{
    margin-top: 4px;
  }

  .ant-select-selector {
    /* height: 40px !important; */
    align-items: center;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    border-color: #333;
    // border-radius: 46px !important;
    color: #333333;

    &:focus,
    &:hover {
      /* border-color: #333 !important; */
    }
    .ant-select-selection-search{
      /* margin-top: 8px; */
    }


  }

  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    /* border-color: #333; */
  }
  .ant-select-arrow {
    /* color: #33363f; */
  }
  
`;

export const StyledDropdownContainer = styled.div`
  /* border-radius: 46px; */
  /* min-width: 140px; */
`;

export const Label = styled.label<{ fontWeight: string }>`
  font-weight: ${(props) => props.fontWeight};
  font-size: 15px !important;
  color: #000000;
  margin-bottom: 4px;
  display: block;
`;
